import { render } from "./CentralNotasFiscais.vue?vue&type=template&id=483f2014&scoped=true&ts=true"
import script from "./CentralNotasFiscais.vue?vue&type=script&lang=ts"
export * from "./CentralNotasFiscais.vue?vue&type=script&lang=ts"

import "./CentralNotasFiscais.vue?vue&type=style&index=0&id=483f2014&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483f2014"]])

export default __exports__